// separate from ChannelManager.tsx so Router can import the tabs without pulling the
// component into the eager bundle (CN-50866)
export const CHANNEL_MANAGER_TABS = {
  manage: 'manage',
  insights: 'insights',
} as const;

export type ChannelManagerTab = (typeof CHANNEL_MANAGER_TABS)[keyof typeof CHANNEL_MANAGER_TABS];
